export default {
  cpf: {
    placeholder: '000.000.000-00',
    mask: 'cpf',
  },
  cnpj: {
    placeholder: '00.000.000/0000-00',
    mask: 'cnpj',
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-quote/features/freight-quote/components/sc-additional-information/enums/EnumFederalTaxpayer.js